export const createStyles = (theme: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  return {
    container: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: { xs: 343, sm: 360, md: 560 },
      padding: '1rem 1rem',
      bgcolor: 'background.paper',
      borderRadius: '8px',
      height: '695px',
      maxHeight: 'calc(100dvh - 2rem)',
      fontFamily: theme?.typography?.fontFamily,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    header: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      minHeight: '44px',
    },
    title: {
      fontSize: '20px',
      fontWeight: 500,
    },
    content: {
      flex: 1,
      minHeight: 0,
      overflowY: 'scroll',
      py: '20px',
    },
    extensionCount: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      fontSize: '16px',
      fontWeight: 500,
      mb: '12px',
      pb: '12px',
    },
    nameInput: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '4px',
      fontSize: '16px',
      height: '48px',
      px: '12px',
      '&:focus-within': { borderColor: 'primary.main', borderWidth: '1px' },
    },
    summaryHeader: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      mt: '28px',
    },
    sectionTitle: { fontSize: '16px', fontWeight: 500 },
    helperText: {
      color: 'text.secondary',
      mb: '18px',
      mt: '10px',
      fontSize: '12px',
    },
    chip: {
      bgcolor: 'action.selected',
      borderRadius: '18px',
      display: 'inline-flex',
      mt: '10px',
      mb: '16px',
      px: '12px',
      py: '6px',
      fontSize: '13px',
    },
    searchInput: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '4px',
      fontSize: '16px',
      height: '48px',
      mb: '12px',
      px: '12px',
      '&:focus-within': { borderColor: 'primary.main', borderWidth: '1px' },
    },
    searchIcon: { color: isDark ? '#FFFFFF8F' : '#231F298F', mr: '10px' },
    studentList: { listStyle: 'none', m: 0, p: 0, overflowY: 'scroll' },
    studentRow: {
      alignItems: 'center',
      borderBottom: `1px solid ${theme.palette.divider}`,
      display: 'flex',
      minHeight: '64px',
      px: '4px',
    },
    avatar: { flexShrink: 0, height: '40px', mr: '10px', width: '40px' },
    studentDetails: { flex: '1 1 0%', minWidth: 0, overflow: 'hidden' },
    studentName: {
      alignItems: 'baseline',
      display: 'flex',
      fontSize: '16px',
      maxWidth: '100%',
      minWidth: 0,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    studentNameText: {
      display: 'block',
      flex: '1 1 0%',
      maxWidth: '100%',
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    studentEmail: {
      color: 'text.secondary',
      display: 'block',
      fontSize: '15px',
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
      whiteSpace: 'nowrap',
    },
    added: {
      color: 'success.main',
      flexShrink: 0,
      fontWeight: 500,
      ml: '4px',
    },
    addStudent: { color: 'primary.main', flexShrink: 0 },
    removeStudent: { color: 'text.secondary', flexShrink: 0 },
    cohortTitle: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      fontSize: '16px',
      fontWeight: 500,
      mb: 0,
      pb: '16px',
    },
    properties: { display: 'flex', flexDirection: 'column', gap: '16px' },
    field: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '4px',
      display: 'flex',
      minHeight: '52px',
      px: '12px',
      position: 'relative',
      '& input': {
        background: 'transparent',
        border: 0,
        color: 'inherit',
        font: 'inherit',
        outline: 0,
        width: '100%',
      },
    },
    fieldLabel: {
      bgcolor: 'background.paper',
      color: 'text.secondary',
      fontSize: '13px',
      left: '8px',
      px: '4px',
      position: 'absolute',
      top: '-10px',
    },
    descriptionEditor: {
      minHeight: '96px',
      pt: '8px',
      width: '100%',
    },
    switchRow: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      mt: '8px',
    },
    checkboxStyle: {
      '&.MuiFormControlLabel-root': {
        marginRight: '-10px',
      },
    },
    dateField: {
      cursor: 'pointer',
      m: 0,
    },
    datePickerContainer: {
      bgcolor: 'background.paper',
      borderRadius: 2,
      boxShadow: 24,
      maxWidth: '95vw',
      overflow: 'hidden',
      width: 320,
    },
    datePickerTitle: {
      color: 'text.secondary',
      fontSize: '12px',
      fontWeight: 500,
      letterSpacing: '0.08em',
      px: 2,
      pt: 1.5,
    },
    dateTimePicker: {
      boxShadow: 'none',
      width: '100%',
      '& .MuiPickersDay-root.Mui-selected:hover': {
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
      },
    },
    datePickerActions: {
      display: 'flex',
      gap: 1,
      justifyContent: 'flex-end',
      pb: 1.5,
      pt: 0.5,
      px: 2,
    },
    propertiesInfo: {
      backgroundColor: isDark ? '#071318' : '#E5F6FD',
      color: isDark ? '#B8E7FB' : '#014361',
    },
    editedPropertiesAlert: {
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    conflictContent: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      minHeight: 0,
      py: '12px',
    },
    conflictTitle: { fontSize: '18px', fontWeight: 500, mb: '16px' },
    conflictStudents: {
      listStyle: 'none',
      m: 0,
      mt: '12px',
      overflowY: 'auto',
      p: 0,
    },
    conflictActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      mt: '16px',
    },
    footer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      pt: '16px',
    },
    actionButtons: { display: 'flex', gap: '16px' },
  };
};
